<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'매칭상담회'"></sub-visual>
        
        <div class="contents">
            <section class="section">
                <div class="ct">
                    <!-- 탭메뉴 -->
                    <div class="tab-menu">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <TabItem
                                    v-for="item in list"
                                    v-bind="item" :key="item.id"
                                    v-model="currentId" @input="status = list.find(({ id }) => id == currentId).status"/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-contents">
                        <transition>
                            <section class="item" :key="currentId">
                                <!-- {{ current.content }} -->
                                <!-- 상담회 리스트 -->
                                <fair-list :status="status" v-slot:default="{ fairs }">
                                    <fair-list-item v-for="(fair, index) in fairs" :fair="fair" :key="fair._id" :to="`/fairs/${fair._id}`" :color="index % 2 ? 'orange': 'primary'" @apply="apply"></fair-list-item>
                                </fair-list>
                            </section>
                        </transition>
                    </div>
                </div>
            </section>
        </div>

        <fair-modal ref="fair-modal"></fair-modal>
        
    </client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import TabItem from "@/components/client/tab/tab-item.vue";
import FairList from "@/components/client/fair/fair-list.vue";
import FairListItem from '@/components/client/fair/fair-list-item.vue';
import FairModal from "@/components/client/fair/fair-modal.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        TabItem,
        FairList,
        FairListItem,
        FairModal
    },
    data(){
        return{
            currentId: 1,
            status: null,
            list: [
                { id: 1, label: "전체", status: null },
                { id: 2, label: "진행중", status: "진행중" },
                { id: 3, label: "종료", status: "종료" }
            ],
        }
    },
    methods: {
        apply(fair){
            this.$refs["fair-modal"].fair = fair;
            this.$refs["fair-modal"].open();
        }
    },
    computed: {
        current() {
            return this.statuses.find(el => el.id === this.currentId) || {}
        },
    },
};
</script>
<style lang="scss" scoped>
.tab-contents{
    margin-top: 50px;
    .item { transition: all 0.3s ease; background: #fff; }
}
.v-leave-active { position: absolute; }
.v-enter { opacity: 1; }
.v-leave-to { opacity: 0; }
</style>